import config from '@/config';

import PageAuth from "@/components/PageAuth.vue";
import StatisticDashboard from "@/views/statistic/dashboard/Page.vue";

import BasicUser from "@/views/basic/user/Page.vue";
import GoodsScheme from "@/views/goods/scheme/Page.vue";
import GoodsSim from "@/views/goods/sim/Page.vue";
import OrderInvoice from "@/views/order/invoice/Page.vue";
import OrderRecharge from "@/views/order/recharge/Page.vue";
import SystemContact from "@/views/system/contact/Page.vue";
import SystemUser from "@/views/system/user/Page.vue";
import SystemVersion from "@/views/system/version/Page.vue";

export default {
  path: '/backend',
  component: PageAuth,
  children: [
    {
      path: config.homeUrl,
      meta: {title: '主页概况'},
      component: StatisticDashboard,
    },
    {
      path: 'basic/user',
      meta: {title: '客户管理'},
      component: BasicUser,
    },
    {
      path: 'goods/scheme',
      meta: {title: '套餐管理'},
      component: GoodsScheme,
    },
    {
      path: 'goods/sim',
      meta: {title: '卡号管理'},
      component: GoodsSim,
    },
    {
      path: 'order/invoice',
      meta: {title: '开票管理'},
      component: OrderInvoice,
    },
    {
      path: 'order/recharge',
      meta: {title: '订单管理'},
      component: OrderRecharge,
    },
    {
      path: 'system/contact',
      meta: {title: '客服管理'},
      component: SystemContact,
    },
    {
      path: 'system/user',
      meta: {title: '账号管理'},
      component: SystemUser,
    },
    {
      path: 'system/version',
      meta: {title: '版本记录'},
      component: SystemVersion,
    }
  ]
}